import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid, screenSizeSmaller} from 'views/components';

import CaregiverFeed from './caregiver_scenes/caregiver_feed/CaregiverFeed';
import CaregiverSettings from './caregiver_scenes/caregiver_settings/CaregiverSettings';

import _ from 'lodash';
import moment from 'moment';
import backend from 'utils/backend';

const CaregiverView = (props) => {
  const [refresh, setRefresh] = React.useState(1);

  const [caregiverSettingsView, setCaregiverSettingsView] = React.useState('PROFILE_URL');
  const [openDrawerView, setOpenDrawerView] = React.useState(false);

  const [caregiverData, setCaregiverData] = React.useState();
  const [caregiverMessages, setCaregiverMessage] = React.useState({});
  const [caregiverLogs, setCaregiverLogs] = React.useState({});
  const [caregiverChatConversations, setCaregiverChatConversations] = React.useState([]);
  const [caregiverChatMessages, setCaregiverChatMessages] = React.useState({});
  const [caregiverScheduleEvents, setCaregiverScheduleEvents] = React.useState({});
  const [caregiverBio, setCaregiverBio] = React.useState({questions: {}});
  const [caregiverAuth, setCaregiverAuth] = React.useState();
  const [caregiverPaymentSlip, setCaregiverPaymentSlip] = React.useState({});
  const [caregiverPaymentPlan, setCaregiverPaymentPlan] = React.useState({});
  const [caregiverInterviews, setCaregiverInterviews] = React.useState([]);
  const [shortIdRecord, setShortIdRecord] = React.useState({});
  const [caregiverReviews, setCaregiverReviews] = React.useState([]);
  const [caregiverTasks, setCaregiverTasks] = React.useState([]);

  const [caregiverMessagesLastEvaluatedKey, setCaregiverMessagesLastEvaluatedKey] = React.useState(null);
  const [caregiverLogsLastEvaluatedKey, setCaregiverLogsLastEvaluatedKey] = React.useState(null);
  const [caregiverPaymentSlipLastEvaluatedKey, setCaregiverPaymentSlipLastEvaluatedKey] = React.useState(null);

  const [caregiverDataLoaded, setCaregiverDataLoaded] = React.useState(false);
  const [caregiverMessagesLoading, setCaregiverMessagesLoading] = React.useState(false);
  const [caregiverLogsLoading, setCaregiverLogsLoading] = React.useState(false);
  const [caregiverChatConversationsLoading, setCaregiverChatConversationsLoading] = React.useState(false);
  const [caregiverChatMessagesLoading, setCaregiverChatMessagesLoading] = React.useState({});
  const [caregiverPaymentSlipLoading, setCaregiverPaymentSlipLoading] = React.useState(false);
  const [caregiverPaymentPlanLoading, setCaregiverPaymentPlanLoading] = React.useState(false);

  const [feedTab, setFeedTab] = React.useState('CORRESPONDANCE');

  const progressWrap = props.statusProgressWrap;
  const caregiverRn = props.caregiverRn;
  const requester = props.requester;

  const requesterRn = requester.userRn;

  const showSettings = screenSizeSmaller('md');

  React.useEffect(() => {
    caregiverBackend.load.loadCaregiverData(caregiverRn);
  }, [caregiverRn, refresh]);
  React.useEffect(() => {
    caregiverBackend.load.loadMessages(caregiverRn, null);
  }, [caregiverRn, refresh]);
  React.useEffect(() => {
    caregiverBackend.load.loadLogs(caregiverRn, null);
  }, [caregiverRn, refresh]);
  React.useEffect(() => {
    caregiverBackend.load.loadTasks(caregiverRn);
  }, [caregiverRn, refresh]);

  const caregiverBackend = {
    load: {
      loadCaregiverData: async (caregiverRn) => {
        progressWrap(async () => {
          const output = await backend.caregiver.getCaregiver(caregiverRn, true, true, true, true, true, true);
          setCaregiverData(output.caregiverDetail);
          setCaregiverBio(output.caregiverBio);
          setShortIdRecord(output.shortIdRecord);
          setCaregiverReviews(output.caregiverReviews.list);
          setCaregiverInterviews(output.caregiverInterviews.list);
          setCaregiverDataLoaded(true);
        }, {debugString: 'CAREGIVER_LOAD'});
      },
      loadMessages: async (caregiverRn, caregiverMessagesLastEvaluatedKey) => {
        progressWrap(async () => {
          setCaregiverMessagesLoading(true);
          const output = await backend.caregiver.message.load(caregiverRn, caregiverMessagesLastEvaluatedKey, true, true);

          setCaregiverMessage((messages) => {
            const newMessages = output.messages.reduce((result, message) => {
              return {
                ...result,
                [message.messageRn]: message,
              };
            }, {});

            return {
              ...messages,
              ...newMessages,
            };
          });
          setCaregiverMessagesLastEvaluatedKey(output.lastEvaluatedKey);
          setCaregiverMessagesLoading(false);
        }, {debugString: 'CAREGIVER_MESSAGE_LOAD'});
      },
      loadLogs: async (caregiverRn, caregiverLogsLastEvaluatedKey) => {
        progressWrap(async () => {
          setCaregiverLogsLoading(true);
          const output = await backend.caregiver.loadLogs(caregiverRn, caregiverLogsLastEvaluatedKey, true);

          setCaregiverLogs((logs) => {
            const newLogs = output.logs.reduce((result, log) => {
              return {
                ...result,
                [log.caregiverLogRn]: log,
              };
            }, {});

            return {
              ...logs,
              ...newLogs,
            };
          });
          setCaregiverLogsLastEvaluatedKey(output.lastEvaluatedKey);
          setCaregiverLogsLoading(false);
        }, {debugString: 'CAREGIVER_LOGS_LOAD'});
      },
      loadTasks: async (caregiverRn) => {
        progressWrap(async () => {
          const filters = [
            {key: 'resourceRn', value: caregiverRn},
          ];
          const outputResponse = await backend.workflowEngine.queryResourceTasks(filters, null, null);
          const output = outputResponse?.list ?? [];
          setCaregiverTasks(output);
        }, {debugString: 'TASKS_LOAD'});
      },
      loadAuth: async () => {
        progressWrap(async () => {
          const output = await backend.user.getUser(caregiverRn, true);

          setCaregiverAuth(output);
        }, {debugString: 'CAREGIVER_LOGS_LOAD'});
      },
    },
    detail: {
      editDescription: async (newBody, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const body = {
              description: {
                blob: newBody,
                editorType: 'MARKDOWN',
              },
            };
            const {caregiverDetail, updateLog} = await backend.caregiver.updateDescription(caregiverRn, body);

            // Refresh
            setCaregiverData(caregiverDetail);

            setCaregiverLogs((logs) => {
              return {
                ...logs,
                [updateLog.caregiverLogRn]: updateLog,
              };
            });

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_EDIT_DESCRIPTION'});
      },
      editPhoto: async (file, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const type = file.type;
            const name = file.name;
            const body = {
              fileDir: `/public/caregiver/${caregiverRn}/photo`,
              fileType: type,
              fileName: name,
            };
            const {signedUrl, fileUrl} = await backend.fileStorage.uploadFile(body);

            const uploadResult = await backend.s3.upload(signedUrl, file);

            if (uploadResult.status === 200) {
              const {caregiverDetail, updateLog} = await backend.caregiver.updateFile(caregiverRn, {fileUrl});
              setCaregiverData(caregiverDetail);
              setCaregiverLogs((logs) => {
                return {
                  ...logs,
                  [updateLog.caregiverLogRn]: updateLog,
                };
              });
            } else {
              console.error('Upload failed with status', result.status);
            }

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_EDIT_PHOTO'});
      },
      editStatus: async (status, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const body = {
              status,
            };
            const {caregiverDetail, updateLog} = await backend.caregiver.updateStatus(caregiverRn, body);

            // Refresh
            setCaregiverData(caregiverDetail);

            setCaregiverLogs((logs) => {
              return {
                ...logs,
                [updateLog.caregiverLogRn]: updateLog,
              };
            });

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_EDIT_STATUS'});
      },
      editName: async (caregiverName, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const body = {
              caregiverName,
            };
            const {caregiverDetail, updateLog} = await backend.caregiver.updateName(caregiverRn, body);

            // Refresh
            setCaregiverData(caregiverDetail);

            setCaregiverLogs((logs) => {
              return {
                ...logs,
                [updateLog.caregiverLogRn]: updateLog,
              };
            });

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_EDIT_NAME'});
      },
      addContact: async (type, detail, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const body = {
              type,
              detail,
            };
            const {caregiverDetail, updateLog} = await backend.caregiver.addContact(caregiverRn, body);

            // Refresh
            setCaregiverData(caregiverDetail);

            setCaregiverLogs((logs) => {
              return {
                ...logs,
                [updateLog.caregiverLogRn]: updateLog,
              };
            });

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_ADD_CONTACT'});
      },
      removeContact: async (type, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const body = {
              type,
            };
            const {caregiverDetail, updateLog} = await backend.caregiver.removeContact(caregiverRn, body);

            // Refresh
            setCaregiverData(caregiverDetail);

            setCaregiverLogs((logs) => {
              return {
                ...logs,
                [updateLog.caregiverLogRn]: updateLog,
              };
            });

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_REMOVE_CONTACT'});
      },
      updateShortId: async (newShortId, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const body = {
              newShortId,
            };
            const {shortIdRecord} = await backend.caregiver.updateShortId(caregiverRn, body);

            // Refresh
            setShortIdRecord(shortIdRecord);

            onSuccess();
          } catch (error) {
            onError(error);
          }
        }, {debugString: 'CAREGIVER_EDIT_SHORT_ID'});
      },
      addClient: async (clientRn, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const body = {
              clientRn,
            };
            const {caregiverDetail, updateLog} = await backend.caregiver.addClient(caregiverRn, body);

            // Refresh
            setCaregiverData(caregiverDetail);

            setCaregiverLogs((logs) => {
              return {
                ...logs,
                [updateLog.caregiverLogRn]: updateLog,
              };
            });

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_ADD_CLIENT'});
      },
      removeClient: async (clientRn, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const body = {
              clientRn,
            };
            const {caregiverDetail, updateLog} = await backend.caregiver.removeClient(caregiverRn, body);

            // Refresh
            setCaregiverData(caregiverDetail);

            setCaregiverLogs((logs) => {
              return {
                ...logs,
                [updateLog.caregiverLogRn]: updateLog,
              };
            });

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_REMOVE_CLIENT'});
      },
    },
    messages: {
      create: async (messageType, newMessage, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const body = {
              body: {
                blob: newMessage,
                editorType: 'MARKDOWN',
              },
              messageType: messageType,
              requester: {
                rn: requesterRn,
              },
            };
            const result = await backend.caregiver.message.create(caregiverRn, body);

            setCaregiverMessage((messages) => {
              return {
                ...messages,
                [result.messageRn]: result.message,
              };
            });

            if (messageType === 'ANNOUNCEMENTS') {
              setCaregiverData((caregiverData) => {
                return {
                  ...caregiverData,
                  latestAnnouncementMessageRn: result.messageRn,
                  latestAnnouncementMessage: result.message,
                };
              });
            }
            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_MESSAGE_CREATE'});
      },
      sendEmail: async (userRn, emailData, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const result = await backend.notification.sendEmail(userRn, emailData);
            const messageRn = result?.result?.messageRn;
            const message = result?.result?.message;

            if (messageRn && message) {
              setCaregiverMessage((messages) => {
                return {
                  ...messages,
                  [messageRn]: message,
                };
              });
            }

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_MESSAGE_SEND_EMAIL'});
      },
      update: async (messageRn, newMessage, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const body = {
              body: {
                blob: newMessage,
                editorType: 'MARKDOWN',
              },
            };
            const result = await backend.caregiver.message.update(caregiverRn, messageRn, body);

            setCaregiverMessage((messages) => {
              messages[result.messageRn] = result.message;
              return {
                ...messages,
              };
            });

            if (caregiverData.latestAnnouncementMessageRn === result.messageRn) {
              setCaregiverData((caregiverData) => {
                return {
                  ...caregiverData,
                  latestAnnouncementMessageRn: result.messageRn,
                  latestAnnouncementMessage: result.message,
                };
              });
            }

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {
          debugString: 'TICKET_MESSAGE_UPDATE',
        });
      },
      delete: async (messageRn, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const result = await backend.caregiver.message.delete(caregiverRn, messageRn);

            setCaregiverMessage((messages) => {
              delete messages[result.messageRn];
              return {
                ...messages,
              };
            });

            if (caregiverData.latestAnnouncementMessageRn === result.messageRn) {
              setCaregiverData((caregiverData) => {
                return {
                  ...caregiverData,
                  latestAnnouncementMessageRn: null,
                  latestAnnouncementMessage: null,
                };
              });
            }

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {
          debugString: 'TICKET_MESSAGE_DELETE',
        });
      },
      addEmoji: async (messageRn, emoji, userRn, onSuccess=()=>undefined, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const body = {
              emoji: emoji,
              requester: {
                rn: userRn,
              },
            };
            const result = await backend.caregiver.message.emoji.add(caregiverRn, messageRn, body);

            setCaregiverMessage((messages) => {
              messages[result.messageRn] = result.message;
              return {
                ...messages,
              };
            });

            if (caregiverData.latestAnnouncementMessageRn === result.messageRn) {
              setCaregiverData((caregiverData) => {
                return {
                  ...caregiverData,
                  latestAnnouncementMessageRn: result.messageRn,
                  latestAnnouncementMessage: result.message,
                };
              });
            }

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {
          debugString: 'TICKET_MESSAGE_EMOJI_ADD',
        });
      },
      removeEmoji: async (messageRn, emoji, userRn, onSuccess=()=>undefined, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const body = {
              emoji: emoji,
              requester: {
                rn: userRn,
              },
            };
            const result = await backend.caregiver.message.emoji.remove(caregiverRn, messageRn, body);

            setCaregiverMessage((messages) => {
              messages[result.messageRn] = result.message;
              return {
                ...messages,
              };
            });

            if (caregiverData.latestAnnouncementMessageRn === result.messageRn) {
              setCaregiverData((caregiverData) => {
                return {
                  ...caregiverData,
                  latestAnnouncementMessageRn: result.messageRn,
                  latestAnnouncementMessage: result.message,
                };
              });
            }

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {
          debugString: 'TICKET_MESSAGE_EMOJI_REMOVE',
        });
      },
    },
    chat: {
      loadConversations: async () => {
        progressWrap(async () => {
          try {
            setCaregiverChatConversationsLoading(true);

            const result = await backend.communication.getConversationList(caregiverRn);
            setCaregiverChatConversations(result?.list || []);
          } catch (error) {
            console.error(error);
            setCaregiverChatConversations([]);
          } finally {
            setCaregiverChatConversationsLoading(false);
          }
        }, {debugString: 'CAREGIVER_CHAT_LOAD_CONVERSATIONS'});
      },
      loadConversationMessages: async (conversationRn) => {
        if (!conversationRn || caregiverChatMessagesLoading[conversationRn]) {
          return;
        }

        progressWrap(async () => {
          setCaregiverChatMessagesLoading((current) => {
            return {
              ...current,
              [conversationRn]: true,
            };
          });

          try {
            let lastEvaluatedKey = null;
            let output = [];

            do {
              const result = await backend.communication.getConversationMessages(
                  caregiverRn,
                  conversationRn,
                  lastEvaluatedKey,
              );

              output = [
                ...output,
                ...(result?.list || []),
              ];
              lastEvaluatedKey = result?.lastEvaluatedKey || null;
            } while (lastEvaluatedKey);

            setCaregiverChatMessages((current) => {
              return {
                ...current,
                [conversationRn]: output,
              };
            });
          } catch (error) {
            console.error(error);

            setCaregiverChatMessages((current) => {
              return {
                ...current,
                [conversationRn]: [],
              };
            });
          } finally {
            setCaregiverChatMessagesLoading((current) => {
              return {
                ...current,
                [conversationRn]: false,
              };
            });
          }
        }, {debugString: 'CAREGIVER_CHAT_LOAD_MESSAGES'});
      },
    },
    schedule: {
      loadMonthlyEvents: async (byMonths, loadCaregiverUpdates) => {
        progressWrap(async () => {
          const output = await backend.caregiver.schedule.loadByMonth(caregiverRn, byMonths, loadCaregiverUpdates);

          const events = output.events.reduce((result, event) => {
            return {
              ...result,
              [event.eventRn]: event,
            };
          }, {});

          setCaregiverScheduleEvents((e) => {
            return {
              ...e,
              ...events,
            };
          });
        }, {debugString: 'CAREGIVER_SCHEDULE_LOAD_EVENTS'});
      },
    },
    bioQuestions: {
      updateQuestion: async (bioQuestionId, bioQuestion, onSuccess=()=>undefined, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const result = await backend.caregiver.bioQuestion.update(caregiverRn, bioQuestionId, bioQuestion);

            setCaregiverBio(result.caregiverBio);

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {
          debugString: 'CAREGIVER_BIO_UPDATE_QUESTION',
        });
      },
      updateMultipleQuestions: async (bioQuestions, onSuccess = () => undefined) => {
        progressWrap(async () => {
          try {
            const result = await backend.caregiver.bioQuestion.updateMultiple(caregiverRn, bioQuestions);

            setCaregiverBio(result.caregiverBio);
            onSuccess();
          } catch (error) {
            console.error(error);
            throw new Error(error);
          }
        }, {
          debugString: 'CAREGIVER_BIO_UPDATE_MULTIPLE_QUESTIONS',
        });
      },
      getSignedFileUrl: (bioQuestionId, file, isPublic=false, onSuccess=()=>undefined) => {
        return new Promise((resolve, reject) => {
          progressWrap(async () => {
            try {
              const body = {
                fileDir: `${isPublic ? 'public/' : ''}caregiver/${caregiverRn}/${bioQuestionId}`,
                fileName: file.name,
                fileType: file.type,
              };

              const result = await backend.fileStorage.uploadFile(body);
              resolve({
                signedUrl: result.signedUrl,
                fileUrl: result.fileUrl,
                onUploadComplete: onSuccess,
              });
            } catch (error) {
              console.error(error);
              reject(new Error(error));
            }
          });
        });
      },
      getSignedReadUrl: (fileUrl, onSuccess=()=>undefined) => {
        return new Promise((resolve, reject) => {
          progressWrap(async () => {
            try {
              const body = {
                src: fileUrl,
              };

              const result = await backend.fileStorage.downloadFile(body);
              onSuccess();
              resolve(result.signedUrl);
            } catch (error) {
              console.error(error);
              reject(new Error(error));
            }
          });
        });
      },
    },
    auth: {
      setupAuth: async (email, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const name = caregiverData.caregiverName;

            const parts = name.trim().split(/\s+/);

            const firstName = parts[0] || 'undefined';
            const lastName = parts[1] || 'undefined';

            const input = {
              caregiverRn,
              email,
              firstName,
              lastName,
            };
            const output = await backend.user.createCaregiver(input);

            setCaregiverAuth((e) => {
              return {
                ...e,
                ...output,
              };
            });

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_AUTH_SETUP'});
      },
      resetPassword: async (newPassword, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            await backend.user.resetPassword(caregiverRn, newPassword);

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_AUTH_PASSWORD_RESET'});
      },
      removeAuth: async (onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const output = await backend.user.deactivateUser(caregiverRn);

            setCaregiverAuth(output);

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_AUTH_REMOVE'});
      },
      reactivateAuth: async (onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const output = await backend.user.reactivateUser(caregiverRn);

            setCaregiverAuth(output);

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_AUTH_REACTIVATE'});
      },
    },
    payment: {
      loadCaregiverPaymentPlan: async () => {
        progressWrap(async () => {
          setCaregiverPaymentPlanLoading(true);
          const output = await backend.caregiverPaymentPlan.loadCaregiverPaymentPlan(caregiverRn);
          if (output.paymentPlan !== null) {
            setCaregiverPaymentPlan(output.paymentPlan);
          } else {
            setCaregiverPaymentPlan({});
          }
          setCaregiverPaymentPlanLoading(false);
        }, {debugString: 'CAREGIVER_HOURLY_RATE_LOAD'});
      },

      updateCaregiverHourlyRate: async (hourlyRate, onSuccess=()=>undefined, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            const output = await backend.caregiverPaymentPlan.updateCaregiverHourlyRate(caregiverRn, hourlyRate);
            setCaregiverPaymentPlan(output.paymentPlan);

            onSuccess();
          } catch (error) {
            onError();
            console.error(error);
            throw new Error(error);
          }
        }, {debugString: 'CAREGIVER_HOURLY_RATE_UPDATE'});
      },

      loadPaymentSlips: async () => {
        progressWrap(async () => {
          setCaregiverPaymentSlipLoading(true);
          const output = await backend.paymentSlip.queryCaregiverSlip(caregiverRn, caregiverLogsLastEvaluatedKey);


          setCaregiverPaymentSlip((slip) => {
            const newSlip = output.list.reduce((result, log) => {
              return {
                ...result,
                [log.weekOf]: log,
              };
            }, {});

            return {
              ...slip,
              ...newSlip,
            };
          });
          setCaregiverPaymentSlipLastEvaluatedKey(output.lastEvaluatedKey);
          setCaregiverPaymentSlipLoading(false);
        }, {debugString: 'CAREGIVER_PAYMENT_SLIP_LOAD'});
      },
      markAsComplete: async (weekOf) => {
        progressWrap(async () => {
          const {slip} = await backend.paymentSlip.markCaregiverSlipCompete(caregiverRn, weekOf);

          setCaregiverPaymentSlip((slips) => {
            return {
              ...slips,
              [weekOf]: slip,
            };
          });
        }, {debugString: 'CAREGIVER_PAYMENT_SLIP_MARK_COMPLETE'});
      },
    },
    reviews: {
      createCaregiverReview: async (body, onSuccess) => {
        progressWrap(async () => {
          const result = await backend.caregiver.addReview(caregiverRn, body);
          // Refresh
          setCaregiverReviews((reviews) => {
            return [
              ...reviews,
              result.caregiverReview,
            ];
          });

          onSuccess();
        }, {debugString: 'CAREGIVER_ADD_REVIEW'});
      },
      removeCaregiverReview: async (caregiverReviewRn, onSuccess) => {
        progressWrap(async () => {
          const result = await backend.caregiver.removeReview(caregiverRn, caregiverReviewRn);
          // Refresh
          setCaregiverReviews((reviews) => {
            return reviews.filter((review) => review.caregiverReviewRn !== result.caregiverReviewRn);
          });
          onSuccess();
        }, {debugString: 'CAREGIVER_REMOVE_REVIEW'});
      },
    },
    recommendation: {
      createRecommendation: async (body, onSuccess, onError=()=>undefined) => {
        progressWrap(async () => {
          try {
            await backend.caregiver.addRecommendation(caregiverRn, body);
            onSuccess();
          } catch (error) {
            onError(error);
          }
        }, {debugString: 'CAREGIVER_ADD_RECOMMENDATION'});
      },
    },
    tasks: {
      addTask: async (taskData, onComplete=()=>undefined) => {
        progressWrap(async () => {
          try {
            const resultResponse = await backend.workflowEngine.addTask(taskData);
            const result = resultResponse.task;
            const shouldAppend = _.includes(result.connections, caregiverRn);

            if (shouldAppend) {
              setCaregiverTasks((prev) => _.sortBy(
                  [...prev, result],
                  (task) => moment(task?.dueDate).valueOf(),
              ));
            }
            return result;
          } finally {
            onComplete();
          }
        }, {debugString: 'CREATE_TASK'});
      },
      updateTask: async (taskRn, body, onComplete=()=>undefined) => {
        progressWrap(async () => {
          try {
            const input = {
              ...body,
              description: {
                ...body.description,
                editorType: 'TEXT',
              },
            };
            const resultResponse = await backend.workflowEngine.updateTask(taskRn, input);
            const result = resultResponse.task;
            const shouldAppend = _.includes(result?.connections, caregiverRn);
            let nextTasks = caregiverTasks.map((task) => (
              task.taskRn === taskRn ? result : task
            ));
            if (!shouldAppend) {
              nextTasks = _.reject(nextTasks, {taskRn});
            }
            const sortedTasks = _.sortBy(
                nextTasks,
                (task) => moment(task?.dueDate).valueOf() || 0,
            );
            setCaregiverTasks(sortedTasks);
            return result;
          } finally {
            onComplete();
          }
        }, {debugString: 'UPDATE_TASK'});
      },
      removeTask: async (taskRn, onComplete=()=>undefined) => {
        progressWrap(async () => {
          try {
            const result = await backend.workflowEngine.removeTask(taskRn);

            setCaregiverTasks((tasks) => {
              return tasks.filter((task) => task?.taskRn !== taskRn);
            });
            onComplete();
            return result;
          } finally {
            onComplete();
          }
        }, {debugString: 'DELETE_TASK'});
      },
      getTasks: async (connection, onComplete=()=>undefined) => {
        try {
          const filters = [
            {key: 'resourceRn', value: connection},
          ];
          const resultResponse = await backend.workflowEngine.queryResourceTasks(filters, null, null);
          const result = resultResponse?.list || [];
          setCaregiverTasks(result);
          onComplete();
          return result;
        } finally {
          onComplete();
        }
      },
    },
  };


  if (!caregiverDataLoaded) return null;

  return (
    <>
      <Grid container style={{'textAlign': 'left'}}>
        <Grid item md={9} xs={12} >
          <CaregiverFeed
            caregiverRn={caregiverRn}
            feedTab={feedTab}
            setFeedTab={setFeedTab}
            caregiverData={caregiverData}
            caregiverMessages={caregiverMessages}
            caregiverLogs={caregiverLogs}
            caregiverChatConversations={caregiverChatConversations}
            caregiverChatConversationsLoading={caregiverChatConversationsLoading}
            caregiverChatMessages={caregiverChatMessages}
            caregiverChatMessagesLoading={caregiverChatMessagesLoading}
            caregiverScheduleEvents={caregiverScheduleEvents}
            caregiverBioQuestions={caregiverBio}
            caregiverBackend={caregiverBackend}
            caregiverReviews={caregiverReviews}
            caregiverTasks={caregiverTasks}
            refresh={refresh}
            setRefresh={setRefresh}
            showSettings={showSettings}
            setOpenDrawerView={setOpenDrawerView}
            caregiverMessagesLoading={caregiverMessagesLoading}
            caregiverMessagesLastEvaluatedKey={caregiverMessagesLastEvaluatedKey}
            caregiverLogsLastEvaluatedKey={caregiverLogsLastEvaluatedKey}
            caregiverLogsLoading={caregiverLogsLoading}
            caregiverPaymentSlip={caregiverPaymentSlip}
            caregiverPaymentSlipLastEvaluatedKey={caregiverPaymentSlipLastEvaluatedKey}
            caregiverPaymentSlipLoading={caregiverPaymentSlipLoading}
            caregiverPaymentPlan={caregiverPaymentPlan}
            caregiverInterviews={caregiverInterviews}
            caregiverPaymentPlanLoading={caregiverPaymentPlanLoading}
          />
        </Grid>
        <Grid item md={3} pl={{md: 2, xs: 1}}>
          <CaregiverSettings
            showSettings={showSettings}
            openDrawerView={openDrawerView}
            setOpenDrawerView={setOpenDrawerView}
            caregiverSettingsView={caregiverSettingsView}
            setCaregiverSettingsView={setCaregiverSettingsView}
            caregiverRn={caregiverRn}
            caregiverData={caregiverData}
            caregiverBioQuestions={caregiverBio}
            caregiverAuth={caregiverAuth}
            shortIdRecord={shortIdRecord}
            caregiverBackend={caregiverBackend}
            refresh={refresh}
            setRefresh={setRefresh}
          />
        </Grid>
      </Grid>
    </>
  );
};

CaregiverView.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
  requester: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  requester: state.user,
});

export default connect(mapStateToProps, dispatch)(React.memo(CaregiverView));
